import React from 'react';
import { Info } from 'lucide-react';

export function Copyright({ copyright }: { copyright: string }) {
	return (
		<div className="rounded border-l-4 border-gray-300 bg-gray-50 p-4 pl-6 text-gray-700">
			<div className="flex items-center gap-2">
				<Info size={18} />
				<div className="flex flex-col">
					<div>Copyright Information:</div>
					<div
						dangerouslySetInnerHTML={{
							__html: copyright
						}}
					/>
				</div>
			</div>
		</div>
	);
}
